// src/lib/kinema/konva/EditorProvider.tsx
import { createContext, useContext, useRef, type ReactNode } from 'react';
import type { Editor } from '../core/Editor';

const EditorContext = createContext<Editor | null>(null);

export function EditorProvider({
  editor,
  children,
}: {
  editor: Editor;
  children: ReactNode;
}) {
  // Store editor in ref to keep it stable across renders
  const editorRef = useRef(editor);
  return (
    <EditorContext.Provider value={editorRef.current}>
      {children}
    </EditorContext.Provider>
  );
}

export function useEditorContext(): Editor {
  const editor = useContext(EditorContext);
  if (!editor) {
    throw new Error('useEditorContext must be used within <EditorProvider>');
  }
  return editor;
}
